class FurniGalleryCatalogMenu extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-fg-room-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-fg-room-panel]'));
    this.image = this.querySelector('.fg-catalog-mega__image');
    this.desktopDisclosure = this.closest('details-disclosure');
    this.handleDesktopOutsidePointerDown = this.onDesktopOutsidePointerDown.bind(this);
    this.imageRequest = 0;
    this.currentImage = this.image?.currentSrc || this.image?.src || '';

    document.addEventListener('pointerdown', this.handleDesktopOutsidePointerDown, true);

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('mouseenter', () => this.activateTab(tab));
      tab.addEventListener('focus', () => this.activateTab(tab));
      tab.addEventListener('click', () => this.activateTab(tab));
      tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
    });

    this.querySelectorAll('[data-fg-menu-image]').forEach((item) => {
      item.addEventListener('mouseenter', () => this.updateImageFrom(item));
      item.addEventListener('focus', () => this.updateImageFrom(item));
    });
  }

  disconnectedCallback() {
    document.removeEventListener('pointerdown', this.handleDesktopOutsidePointerDown, true);
  }

  onDesktopOutsidePointerDown(event) {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    if (!this.desktopDisclosure?.mainDetailsToggle?.open) return;
    if (this.desktopDisclosure.contains(event.target)) return;

    this.desktopDisclosure.close();
  }

  activateTab(tab) {
    const room = tab.dataset.fgRoomTab;

    this.tabs.forEach((item) => {
      const isActive = item === tab;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', String(isActive));
      item.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.fgRoomPanel === room;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });

    this.updateImageFrom(tab);
  }

  onTabKeydown(event, currentIndex) {
    let nextIndex = null;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;

    if (nextIndex === null) return;
    event.preventDefault();
    this.activateTab(this.tabs[nextIndex]);
    this.tabs[nextIndex].focus();
  }

  updateImageFrom(item) {
    const url = item.dataset.fgMenuImage;
    if (!url || !this.image || url === this.currentImage) return;

    const request = ++this.imageRequest;
    const loader = new Image();

    loader.onload = () => {
      if (request !== this.imageRequest) return;

      this.image.classList.add('is-changing');
      window.setTimeout(() => {
        if (request !== this.imageRequest) return;
        this.image.removeAttribute('srcset');
        this.image.removeAttribute('sizes');
        this.image.src = url;
        this.currentImage = url;
        window.requestAnimationFrame(() => this.image.classList.remove('is-changing'));
      }, 120);
    };

    loader.src = url;
  }
}

class FurniGalleryMobileCatalog extends HTMLElement {
  connectedCallback() {
    this.rooms = Array.from(this.querySelectorAll('[data-fg-mobile-room]'));
    this.rooms.forEach((room) => {
      const toggle = room.querySelector('[data-fg-mobile-room-toggle]');
      toggle?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggleRoom(room);
      });
    });
  }

  toggleRoom(selectedRoom) {
    const shouldOpen = !selectedRoom.classList.contains('is-open');

    this.rooms.forEach((room) => {
      const isOpen = room === selectedRoom && shouldOpen;
      const toggle = room.querySelector('[data-fg-mobile-room-toggle]');
      const panel = room.querySelector('[data-fg-mobile-room-panel]');

      room.classList.toggle('is-open', isOpen);
      toggle?.setAttribute('aria-expanded', String(isOpen));
      if (panel) panel.hidden = !isOpen;
    });
  }
}

if (!customElements.get('fg-catalog-menu')) {
  customElements.define('fg-catalog-menu', FurniGalleryCatalogMenu);
}

if (!customElements.get('fg-mobile-catalog')) {
  customElements.define('fg-mobile-catalog', FurniGalleryMobileCatalog);
}
